<div class="bg-gray-100/40 min-h-screen flex items-center justify-center">
  <div
    class="bg-white w-3/4 shadow-md md:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center">
    <div class="w-full mb-2">
      <button (click)="goBack()"
        class="bg-gray-100/60 hover:bg-primary hover:text-white hover:shadow-lg transition ease-in-out duration-150 shadow-md rounded-2xl px-3 py-2">{{"Back"
        | concat | translate}}</button>
    </div>
    <img src="assets/images/emblem.png" class="w-20" alt="">
    <span class="text-black text-xl font-bold mt-5 mb-2">{{"Change Password" | concat | translate}}</span>

    <div class="block mb-3 pb-3">
      <div class="bg-primary-50 rounded-xl p-4 text-center">
        {{ 'password policy' | concat | translate }}
      </div>
    </div>

    <form (ngSubmit)="submitForm(form.value)" [formGroup]="form" class="w-full mt-3">

      <mat-form-field appearance="outline">
        <mat-label>{{ 'Old Password' | concat | translate }}</mat-label>
        <input [type]="showPassword3 ? 'password' : 'text'" matInput formControlName="oldPassword">
        <button type="button" mat-icon-button matSuffix (click)="showPassword3 = !showPassword3"
          [attr.aria-label]="'Hide'" [attr.aria-pressed]="showPassword3">
          <mat-icon class="material-icons-outlined">{{ showPassword3 ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span *ngIf="!form.get('oldPassword')?.valid && form.get('oldPassword')?.touched">
            {{ 'Field is required' | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline">
        <mat-label>{{ 'New Password' | concat | translate }}</mat-label>
        <input [type]="showPassword ? 'password' : 'text'" matInput formControlName="newPassword">
        <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword"
          [attr.aria-label]="'Hide'" [attr.aria-pressed]="showPassword">
          <mat-icon class="material-icons-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span *ngIf="!form.get('newPassword')?.valid && form.get('newPassword')?.touched">
            {{ 'password-must-meet-the-criteria-defined' | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'Confirm Password' | concat | translate }}</mat-label>
        <input [type]="showPassword2 ? 'password' : 'text'" matInput formControlName="confirmPassword">
        <button type="button" mat-icon-button matSuffix (click)="showPassword2 = !showPassword2"
          [attr.aria-label]="'Hide'" [attr.aria-pressed]="showPassword2">
          <mat-icon class="material-icons-outlined">{{ showPassword2 ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span *ngIf="!form.get('confirmPassword')?.valid && form.get('confirmPassword')?.touched">
            {{ 'Field is required' | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <div class="w-full mb-3">
        <button [disabled]="!form.valid || loading" class="w-full" mat-raised-button color="primary"
          type="submit">{{"Change Password" | concat | translate}}</button>
      </div>
    </form>
  </div>
</div>
